import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/* eslint-disable max-len */
import React from 'react';
import IconBase from 'react-icon-base';
export var makeIcon = function makeIcon(_ref) {
  var _ref$displayName = _ref.displayName,
      displayName = _ref$displayName === void 0 ? 'Icon' : _ref$displayName,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? 18 : _ref$viewBox,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? React.createElement("svg", null, React.createElement("g", null)) : _ref$content,
      _ref$viewBoxWidth = _ref.viewBoxWidth,
      viewBoxWidth = _ref$viewBoxWidth === void 0 ? viewBox : _ref$viewBoxWidth,
      _ref$viewBoxHeight = _ref.viewBoxHeight,
      viewBoxHeight = _ref$viewBoxHeight === void 0 ? viewBox : _ref$viewBoxHeight;

  var IconComponent = function IconComponent(props) {
    var color = props.color,
        hGradient = props.hGradient,
        otherProps = _objectWithoutProperties(props, ["color", "hGradient"]);

    return React.createElement(IconBase, Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(viewBoxWidth, " ").concat(viewBoxWidth)
    }, otherProps), hGradient && React.createElement("linearGradient", {
      x1: "100%",
      y1: "100%",
      x2: "0%",
      y2: "0%",
      id: "linearGradient-1"
    }, React.createElement("stop", {
      stopColor: hGradient.startColor,
      offset: "0%"
    }), React.createElement("stop", {
      stopColor: hGradient.endColor,
      offset: "100%"
    })), React.createElement("g", {
      fill: hGradient ? 'url(#linearGradient-1)' : color || 'currentColor'
    }, content));
  };

  IconComponent.displayName = displayName;
  return IconComponent;
};
export var AllNotesIcon = makeIcon({
  displayName: 'AllNotesIcon',
  viewBox: 16,
  content: React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10C12 10.5523 12.4477 11 13 11C14.6569 11 16 9.65685 16 8V3C16 1.34315 14.6569 0 13 0H8C6.34315 0 5 1.34315 5 3C5 3.55196 5.44745 3.99941 5.99941 3.99941H6.03229C6.58425 3.99941 7.0317 3.55196 7.0317 3C7.0317 3 6.94603 1.98127 8 1.98127H13C13 1.98127 14.0393 2.00059 14.0393 3V8C14.0393 8 14.0093 9 13 9C12.4477 9 12 9.44771 12 10ZM3 5H8C9.65685 5 11 6.34315 11 8V13C11 14.6569 9.65685 16 8 16H3C1.34315 16 0 14.6569 0 13V8C0 6.34315 1.34315 5 3 5ZM2 8C2 7.44772 2.44772 7 3 7H8C8.55228 7 9 7.44772 9 8V13C9 13.5523 8.55228 14 8 14H3C2.44772 14 2 13.5523 2 13V8Z"
  })
});
export var ArchiveIcon = makeIcon({
  displayName: 'ArchiveIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M6 9h4a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2z"
  }), React.createElement("path", {
    d: "M12 0a2 2 0 0 1 2 2v1.268A2 2 0 0 1 15 5v1.268A2 2 0 0 1 16 8v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8a2 2 0 0 1 1-1.732V5a2 2 0 0 1 1-1.732V2a2 2 0 0 1 2-2h8zM4 3h8V2H4v1zM3 6h10V5H3v1zM2 8v6h12V8H2z"
  }))
});
export var ArrowLeftIcon = makeIcon({
  displayName: 'ArrowLeftIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M6.53712 5.87868C6.92765 5.48815 6.92765 4.85499 6.53712 4.46446C6.1466 4.07394 5.51343 4.07394 5.12291 4.46446L2.36 7.22737C2.14 7.41081 2 7.68694 2 7.99578C2 8.12255 2.02359 8.24382 2.06662 8.35542C2.11527 8.48363 2.19123 8.60385 2.29448 8.7071L5.12291 11.5355C5.51343 11.9261 6.1466 11.9261 6.53712 11.5355C6.92765 11.145 6.92765 10.5118 6.53712 10.1213L5.41159 8.99578H13C13.5523 8.99578 14 8.54807 14 7.99578C14 7.4435 13.5523 6.99578 13 6.99578H5.42002L6.53712 5.87868Z"
  })
});
export var ArrowTopIcon = makeIcon({
  displayName: 'ArrowTopIcon',
  content: React.createElement("g", {
    transform: "translate(16) rotate(90.000000)"
  }, React.createElement("path", {
    d: "M6.53712 5.87868C6.92765 5.48816 6.92765 4.85499 6.53712 4.46447C6.1466 4.07394 5.51343 4.07394 5.12291 4.46447L2.36 7.22738C2.14 7.41081 2 7.68695 2 7.99578C2 8.12256 2.02359 8.24383 2.06662 8.35544C2.11528 8.48364 2.19123 8.60386 2.29448 8.70711L5.12291 11.5355C5.51343 11.9261 6.1466 11.9261 6.53712 11.5355C6.92765 11.145 6.92765 10.5118 6.53712 10.1213L5.41159 8.99578H13C13.5523 8.99578 14 8.54807 14 7.99578C14 7.4435 13.5523 6.99578 13 6.99578H5.42002L6.53712 5.87868Z"
  }))
});
export var ArrowRightIcon = makeIcon({
  displayName: 'ArrowRightIcon',
  content: React.createElement("path", {
    d: "M9.46288 10.1213C9.07235 10.5118 9.07235 11.145 9.46288 11.5355C9.8534 11.9261 10.4866 11.9261 10.8771 11.5355L13.64 8.77263C13.86 8.58919 14 8.31306 14 8.00422C14 7.87745 13.9764 7.75618 13.9334 7.64458C13.8847 7.51637 13.8088 7.39615 13.7055 7.2929L10.8771 4.46447C10.4866 4.07394 9.8534 4.07394 9.46288 4.46447C9.07235 4.85499 9.07235 5.48816 9.46288 5.87868L10.5884 7.00422L3 7.00422C2.44772 7.00422 2 7.45193 2 8.00422C2 8.5565 2.44772 9.00422 3 9.00422L10.58 9.00422L9.46288 10.1213Z"
  })
});
export var ArrowBottomIcon = makeIcon({
  viewBox: 16,
  displayName: 'ArrowBottomIcon',
  content: React.createElement("g", {
    transform: "translate(0, 16) rotate(270.000000)"
  }, React.createElement("path", {
    d: "M6.53712 5.87868C6.92765 5.48816 6.92765 4.85499 6.53712 4.46447C6.1466 4.07394 5.51343 4.07394 5.12291 4.46447L2.36 7.22738C2.14 7.41081 2 7.68695 2 7.99578C2 8.12256 2.02359 8.24383 2.06662 8.35544C2.11528 8.48364 2.19123 8.60386 2.29448 8.70711L5.12291 11.5355C5.51343 11.9261 6.1466 11.9261 6.53712 11.5355C6.92765 11.145 6.92765 10.5118 6.53712 10.1213L5.41159 8.99578H13C13.5523 8.99578 14 8.54807 14 7.99578C14 7.4435 13.5523 6.99578 13 6.99578H5.42002L6.53712 5.87868Z"
  }))
});
export var AttachmentIcon = makeIcon({
  displayName: 'AttachmentIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M13.545 7.355l.309-.31c1.434-1.433 1.488-3.703.12-5.07-1.366-1.367-3.636-1.313-5.07.12l-6.829 6.83c-1.434 1.434-1.488 3.704-.12 5.07 1.366 1.368 3.636 1.313 5.07-.12l3.924-3.924c.912-.913.947-2.357.077-3.227-.87-.87-2.315-.836-3.227.077l-3.472 3.472c-.391.391-.406 1.01-.033 1.383s.992.358 1.383-.033l3.472-3.472a.326.326 0 01.461-.011c.124.124.12.33-.011.46l-3.924 3.925c-.652.651-1.684.676-2.305.055-.621-.621-.401-1.7.25-2.351l6.83-6.83c.651-.651 1.488-.63 2.109-.008.621.621.597 1.653-.055 2.305l-.31.309c-.39.39-.405 1.01-.032 1.383.373.372.992.358 1.383-.033z"
  })
});
export var BoldIcon = makeIcon({
  displayName: 'BoldIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M6 7h2.75a2.5 2.5 0 000-5H6v5zm0 7h3.5a2.5 2.5 0 000-5H6v5zm2.87 2H3a1 1 0 110-2h1V2h-.906a1 1 0 010-2H8.98a4.271 4.271 0 014.271 4.271v.463A3.473 3.473 0 0111.5 7.75a3.977 3.977 0 012.5 3.693v.234A4.323 4.323 0 019.677 16H8.87z"
  })
});
export var BracketsIcon = makeIcon({
  displayName: 'BracketsIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M4.065 7.362c-.299.36-.587.572-.864.638.266.055.551.262.856.621.305.359.457.87.457 1.532v2.468c0 .939.482 1.408 1.447 1.408h.053a.985.985 0 110 1.971h-.053c-2.472 0-3.708-1.17-3.708-3.511v-1.79c0-1.092-.405-1.639-1.214-1.639A1.04 1.04 0 010 8.02v-.057c0-.574.465-1.04 1.04-1.04.808 0 1.213-.546 1.213-1.64V3.512C2.253 1.171 3.489 0 5.961 0h.053a.986.986 0 010 1.971h-.053c-.965 0-1.447.47-1.447 1.408V5.83c0 .663-.15 1.173-.449 1.532zm7.87 0c.299.36.587.572.864.638-.266.055-.551.262-.856.621-.305.359-.457.87-.457 1.532v2.468c0 .939-.482 1.408-1.447 1.408h-.053a.985.985 0 100 1.971h.053c2.472 0 3.708-1.17 3.708-3.511v-1.79c0-1.092.405-1.639 1.214-1.639A1.04 1.04 0 0016 8.02v-.057a1.04 1.04 0 00-1.04-1.04c-.808 0-1.213-.546-1.213-1.64V3.512c0-2.34-1.236-3.511-3.708-3.511h-.053a.986.986 0 000 1.971h.053c.965 0 1.447.47 1.447 1.408V5.83c0 .663.15 1.173.449 1.532z"
  })
});
export var BrokenMediaIcon = makeIcon({
  displayName: 'BrokenMediaIcon',
  content: React.createElement("path", {
    d: "M.293 14.293a1 1 0 1 0 1.414 1.414l1-1 12-12 1-1A1 1 0 0 0 14.293.293l-14 14zM12 15H5.243l2-2H12a1 1 0 0 0 1-1V7.243l2-2V12a3 3 0 0 1-3 3zM8.757 3H4a1 1 0 0 0-1 1v4.757l-2 2V4a3 3 0 0 1 3-3h6.757l-2 2z"
  })
});
export var BulletListIcon = makeIcon({
  displayName: 'BulletListIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M0 3a2 2 0 104 0 2 2 0 00-4 0zm0 5a2 2 0 104 0 2 2 0 00-4 0zm2 7a2 2 0 110-4 2 2 0 010 4zM6 2a1 1 0 000 2h9a1 1 0 100-2H6zM5 8a1 1 0 011-1h9a1 1 0 110 2H6a1 1 0 01-1-1zm1 4a1 1 0 100 2h9a1 1 0 100-2H6z"
  })
});
export var CalendarIcon = makeIcon({
  displayName: 'CalendarIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C5.55228 0 6 0.447715 6 1V1.5H10V1C10 0.447715 10.4477 0 11 0C11.5523 0 12 0.447715 12 1V1.5H13C14.6569 1.5 16 2.84315 16 4.5V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V4.5C0 2.84315 1.34315 1.5 3 1.5H4V1C4 0.447715 4.44772 0 5 0ZM10 3.5V3.99739C10 4.54968 10.4477 4.99739 11 4.99739C11.5523 4.99739 12 4.54968 12 3.99739V3.5H13C13.5523 3.5 14 3.94772 14 4.5V5.99392L2 6V4.5C2 3.94772 2.44772 3.5 3 3.5H4V3.99739C4 4.54968 4.44772 4.99739 5 4.99739C5.55228 4.99739 6 4.54968 6 3.99739V3.5H10ZM2 8V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V7.99392L2.00051 8H2ZM4 10.9935C4 10.4412 4.44772 9.99348 5 9.99348H6C6.55228 9.99348 7 10.4412 7 10.9935C7 11.5458 6.55228 11.9935 6 11.9935H5C4.44772 11.9935 4 11.5458 4 10.9935ZM10 9.99348C9.44771 9.99348 9 10.4412 9 10.9935C9 11.5458 9.44771 11.9935 10 11.9935H11C11.5523 11.9935 12 11.5458 12 10.9935C12 10.4412 11.5523 9.99348 11 9.99348H10Z",
    fill: "currentColor"
  }))
});
export var CaretBottomIcon = makeIcon({
  displayName: 'CaretBottomIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M13.255 7.287l-3.718 4.11c-.74.82-2.005.883-2.825.142-.05-.046-.097-.094-.142-.144l-3.715-4.11c-.74-.82-.677-2.084.143-2.825.367-.33.845-.515 1.34-.515h7.433c1.106 0 2 .895 2 2 0 .496-.183.974-.515 1.342z"
  }))
});
export var CheckboxIcon = makeIcon({
  displayName: 'CheckboxIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M2 3a1 1 0 011-1h7.692a1 1 0 100-2H3a3 3 0 00-3 3v10a3 3 0 003 3h10a3 3 0 003-3V9.615a1 1 0 10-2 0V13a1 1 0 01-1 1H3a1 1 0 01-1-1V3zm3.207 4.263a1 1 0 00-1.414 1.415l2.97 2.97a1 1 0 001.415 0l7.47-7.47a1 1 0 00-1.414-1.415L7.471 9.527 5.207 7.263z"
  })
});
export var CheckIcon = makeIcon({
  displayName: 'CheckIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M3.7 8.517c-.396-.386-1.03-.38-1.415.017-.386.395-.38 1.028.016 1.414l2.765 2.7c.425.414 1.116.37 1.484-.096l7.054-8.932c.342-.434.268-1.062-.165-1.405-.435-.342-1.064-.268-1.406.165l-6.366 8.06-1.97-1.923z"
  })
});
export var CheckboxEmptyIcon = makeIcon({
  displayName: 'CheckboxEmptyIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M2 2v12h12V2H2zm0-2h12c1.105 0 2 .895 2 2v12c0 1.105-.895 2-2 2H2c-1.105 0-2-.895-2-2V2C0 .895.895 0 2 0z"
  }))
});
export var CheckboxCheckedIcon = makeIcon({
  displayName: 'CheckboxCheckedIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M2 3.5a1 1 0 0 1 1-1h7.692a1 1 0 1 0 0-2H3a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-3.385a1 1 0 1 0-2 0V13.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-10zm3.207 4.263a1 1 0 0 0-1.414 1.415l2.97 2.97a1 1 0 0 0 1.415 0l7.47-7.47a1 1 0 0 0-1.414-1.415l-6.763 6.764-2.264-2.264z"
  }))
});
export var ChevronIcon = makeIcon({
  displayName: 'ChevronIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M10.7071068,5.70710678 C11.0976311,5.31658249 11.0976311,4.68341751 10.7071068,4.29289322 C10.3165825,3.90236893 9.68341751,3.90236893 9.29289322,4.29289322 L6.29289322,7.29289322 C5.90236893,7.68341751 5.90236893,8.31658249 6.29289322,8.70710678 L9.29289322,11.7071068 C9.68341751,12.0976311 10.3165825,12.0976311 10.7071068,11.7071068 C11.0976311,11.3165825 11.0976311,10.6834175 10.7071068,10.2928932 L8.41421356,8 L10.7071068,5.70710678 Z",
    transform: "matrix(-1 0 0 1 17 0)"
  })
});
export var ChevronSmallUp = makeIcon({
  displayName: 'ChevronSmallUp',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M2.343 11.143a1 1 0 010-1.414l4.95-4.95a1 1 0 011.414 0l4.95 4.95a1 1 0 11-1.414 1.414L8 6.901l-4.243 4.242a1 1 0 01-1.414 0z"
  })
});
export var ChevronSmallDown = makeIcon({
  displayName: 'ChevronSmallDown',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M13.657 4.837a1 1 0 010 1.414l-4.95 4.95a1 1 0 01-1.414 0l-4.95-4.95a1 1 0 111.414-1.414L8 9.079l4.243-4.242a1 1 0 011.414 0z"
  })
});
export var CircledCross = makeIcon({
  displayName: 'CircledCross',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M16 8.5a8 8 0 1 0-16 0 8 8 0 0 0 16 0zm-14 0a6 6 0 1 1 12 0 6 6 0 0 1-12 0zm4.94 2.121a.75.75 0 1 1-1.061-1.06L6.939 8.5 5.88 7.44a.75.75 0 0 1 1.06-1.061L8 7.439l1.06-1.06a.75.75 0 1 1 1.061 1.06L9.061 8.5l1.06 1.06a.75.75 0 1 1-1.06 1.061L8 9.561l-1.06 1.06z"
  })
});
export var ClockIcon = makeIcon({
  displayName: 'ClockIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M0 8a8 8 0 1016 0A8 8 0 000 8zm14 0A6 6 0 112 8a6 6 0 0112 0zM7 5a1 1 0 012 0v3h2a1 1 0 110 2H8a1 1 0 01-1-1V5z"
  })
});
export var CloseIcon = makeIcon({
  displayName: 'CloseIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M8 6.5l5.1-5.1c.4-.4 1.1-.4 1.5 0 .4.4.4 1.1 0 1.5L9.5 8l5.1 5.1c.4.4.4 1.1 0 1.5-.4.4-1.1.4-1.5 0L8 9.5l-5.1 5.2c-.4.4-1.1.4-1.5 0-.4-.4-.4-1.1 0-1.5L6.5 8 1.3 2.9c-.4-.4-.4-1.1 0-1.5s1.1-.4 1.5 0L8 6.5z"
  })
});
export var CodeIcon = makeIcon({
  displayName: 'CodeIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M6.053 10.606l2-5.926a1 1 0 011.895.64l-2 5.926a1 1 0 11-1.895-.64zM4.707 5.707a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L2.414 8l2.293-2.293zm6.586 0a1 1 0 011.414-1.414l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L13.586 8l-2.293-2.293z"
  })
});
export var CommentsEmptyIcon = makeIcon({
  displayName: 'CommentsEmpty',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M12.8 11.3c0-.4.1-.8.4-1.1.5-.9.8-1.9.8-2.9C14 4.4 11.4 2 8 2S2 4.4 2 7.3s2.6 5.3 6 5.3c.4 0 .9 0 1.3-.1.3-.1.7 0 1 .1l2.4.8v-2.1zm2 4.2v.2c-.1.3-.4.4-.6.3l-4.4-1.5c-.5.1-1.1.2-1.7.2-4.4 0-8-3.3-8-7.3S3.6 0 8 0s8 3.3 8 7.3c0 1.4-.5 2.8-1.2 3.9v4.3z"
  }))
});
export var CommentsIcon = makeIcon({
  displayName: 'CommentsIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M14.743 15.657a.5.5 0 00.025-.157v-4.248A6.868 6.868 0 0016 7.338C16 3.285 12.418 0 8 0S0 3.285 0 7.338s3.582 7.338 8 7.338c.582 0 1.15-.057 1.697-.165l4.414 1.464a.5.5 0 00.632-.318zm-1.622-5.54a2 2 0 00-.353 1.135v2.17l-2.441-.81a2.001 2.001 0 00-1.019-.063A6.729 6.729 0 018 12.676c-3.35 0-6-2.43-6-5.338S4.65 2 8 2s6 2.43 6 5.338c0 .994-.305 1.947-.88 2.78z"
  })
});
export var DatabaseIcon = makeIcon({
  displayName: 'DatabaseIcon',
  viewBox: 16,
  content: React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.499 0H13.5A2.499 2.499 0 0 1 16 2.499V13.5A2.499 2.499 0 0 1 13.501 16H2.5A2.499 2.499 0 0 1 0 13.501V2.5A2.499 2.499 0 0 1 2.499 0zm6.375 6H14V4H8.874v2zM7 6V4H2v2h5zm0 2v2H2V8h5zm1.874 2V8H14v2H8.874zM7 12H2v1.388c0 .338.274.612.612.612H7v-2zm1.874 2v-2H14v1.388a.612.612 0 0 1-.612.612H8.874z",
    fill: "currentColor"
  })
});
export var DeleteIcon = makeIcon({
  displayName: 'DeleteIcon',
  content: React.createElement("g", null, React.createElement("rect", {
    x: "4.5",
    y: "0",
    width: "9",
    height: "2.25",
    rx: "1.125"
  }), React.createElement("rect", {
    x: "0",
    y: "4.5",
    width: "18",
    height: "2.25",
    rx: "1.125"
  }), React.createElement("path", {
    d: "M4.906 6.75l1.5 9h5.188l1.5-9H4.906zM3.578 4.5h10.844c.62 0 1.125.504 1.125 1.125 0 .062-.005.124-.015.185l-1.875 11.25c-.09.542-.56.94-1.11.94H5.453c-.55 0-1.02-.398-1.11-.94L2.468 5.81c-.102-.613.312-1.193.925-1.295.06-.01.123-.015.185-.015z"
  }))
});
export var DlIcon = makeIcon({
  displayName: 'DlIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M8.813 8.89V.9c0-.497-.403-.9-.9-.9-.498 0-.9.403-.9.9v8.01L5.537 7.434c-.352-.352-.922-.352-1.274 0s-.352.922 0 1.274L7.2 11.644c.252.252.616.324.932.214.19-.025.372-.11.517-.256l2.935-2.936c.352-.352.352-.922 0-1.274s-.922-.352-1.274 0l-1.5 1.5zM16 15c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1s.448-1 1-1h14c.552 0 1 .448 1 1z"
  }))
});
export var EmbedIcon = makeIcon({
  displayName: 'EmbedIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M3 0a3 3 0 00-3 3v10a3 3 0 003 3h10a3 3 0 003-3V3a3 3 0 00-3-3H3zM2 3a1 1 0 011-1h10a1 1 0 011 1v10a1 1 0 01-1 1H3a1 1 0 01-1-1V3zm5.153 7.306l3.2-1.875a.5.5 0 000-.862l-3.2-1.875a.5.5 0 00-.753.431v3.75a.5.5 0 00.753.431z"
  })
});
export var EmojiIcon = makeIcon({
  displayName: 'EmojiIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M8 16A8 8 0 118 0a8 8 0 010 16zm0-2A6 6 0 108 2a6 6 0 000 12zM7 6a1 1 0 10-2 0 1 1 0 002 0zm3-1a1 1 0 110 2 1 1 0 010-2zm-2 7a3 3 0 003-3H5a3 3 0 003 3z"
  })
});
export var ExpandIcon = makeIcon({
  displayName: 'ExpandIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M15 0c.6 0 1 .4 1 1v3c0 .6-.4 1-1 1s-1-.4-1-1V2h-2c-.5 0-1-.4-1-1 0-.5.4-1 1-1h3zm1 12v3c0 .6-.4 1-1 1h-2.9c-.6 0-1-.5-1-1 0-.6.5-1 1-1h2v-2c0-.5.4-1 1-1 .5.1.9.5.9 1zM4.1 16H1c-.6 0-1-.4-1-1v-3c0-.6.5-1 1-1 .6 0 1 .5 1 1v2h2c.6 0 1 .5 1 1 .1.5-.4 1-.9 1zM3.4 2l2.3 2.5c.4.4.3 1-.1 1.4-.4.4-1 .3-1.4-.1L2 3.4V4c0 .6-.5 1-1 1-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h3.1c.6 0 1 .4 1 1s-.4 1-1 1h-.7zm11.3.7l-2.9 3.2c-.4.4-1 .4-1.4.1-.4-.4-.4-1-.1-1.4l2.9-3.2c.4-.4 1-.4 1.4-.1.4.3.5.9.1 1.4zm-4.4 9c-.4-.4-.3-1 .1-1.4.4-.4 1-.3 1.4.1l2.9 3.2c.4.4.3 1-.1 1.4-.4.4-1 .3-1.4-.1l-2.9-3.2zm-4.6 0l-2.9 3.2c-.4.4-1 .4-1.4.1-.4-.4-.4-1-.1-1.4l2.9-3.2c.4-.4 1-.4 1.4-.1.4.3.5.9.1 1.4z"
  })
});
export var ExternalLinkIcon = makeIcon({
  displayName: 'ExternalLinkIcon',
  content: React.createElement("path", {
    d: "M2 3C2 2.44772 2.44772 2 3 2H6C6.55228 2 7 1.55228 7 1C7 0.447715 6.55228 0 6 0H3C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H13C14.6569 16 16 14.6569 16 13V10C16 9.44772 15.5523 9 15 9C14.4477 9 14 9.44772 14 10V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3ZM15 6C14.4477 6 14 5.55228 14 5V3.41363L8.91909 8.49455C8.51436 8.89928 7.85816 8.89928 7.45343 8.49455C7.0487 8.08982 7.0487 7.43362 7.45343 7.02889L12.4823 2L11 2C10.4477 2 10 1.55228 10 0.999999C10 0.447715 10.4477 0 11 0H15C15.5523 0 16 0.447715 16 1V5C16 5.55228 15.5523 6 15 6Z"
  })
});
export var EyeIcon = makeIcon({
  displayName: 'EyeIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M8 11.635C6.02644 11.635 4.09318 10.545 2.22271 7.9975C4.09318 5.45002 6.02644 4.36 8 4.36C9.97356 4.36 11.9068 5.45002 13.7773 7.9975C11.9068 10.545 9.97356 11.635 8 11.635ZM8 2.36C4.95786 2.36 2.35755 4.20274 0.171458 7.43757C-0.0571525 7.77586 -0.0571525 8.21914 0.171458 8.55743C2.35755 11.7923 4.95786 13.635 8 13.635C11.0421 13.635 13.6425 11.7923 15.8285 8.55743C16.0572 8.21914 16.0572 7.77586 15.8285 7.43757C13.6425 4.20274 11.0421 2.36 8 2.36ZM10.5 8C10.5 9.38071 9.38071 10.5 8 10.5C6.61929 10.5 5.5 9.38071 5.5 8C5.5 6.61929 6.61929 5.5 8 5.5C9.38071 5.5 10.5 6.61929 10.5 8Z"
  })
});
export var FilePDFIcon = makeIcon({
  displayName: 'FilePDFIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3C1 1.34315 2.34315 0 4 0H11C12.6569 0 14 1.34315 14 3V6H14.5C15.3284 6 16 6.67157 16 7.5V10.5C16 11.3284 15.3284 12 14.5 12H14V13C14 14.6569 12.6569 16 11 16H4C2.34315 16 1 14.6569 1 13V3ZM12 3V6H6.5C5.67157 6 5 6.67157 5 7.5V10.5C5 11.3284 5.67157 12 6.5 12H12V13C12 13.5523 11.5523 14 11 14H4C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2H11C11.5523 2 12 2.44772 12 3ZM10.7878 7.45H9.82776V10.7H10.8378C11.0711 10.7 11.2869 10.6683 11.4853 10.605C11.6836 10.5417 11.8553 10.4433 12.0003 10.31C12.1453 10.1767 12.2578 10.0067 12.3378 9.8C12.4178 9.59333 12.4578 9.34667 12.4578 9.06C12.4578 8.77333 12.4169 8.52833 12.3353 8.325C12.2536 8.12166 12.1394 7.955 11.9928 7.825C11.8461 7.695 11.6703 7.6 11.4653 7.54C11.2603 7.48 11.0344 7.45 10.7878 7.45ZM12.8156 7.45H14.9356V8.17H13.6756V8.79H14.7556V9.51H13.6756V10.7H12.8156V7.45ZM8.22 7.45H6.96V10.7H7.82V9.67H8.22C8.39 9.67 8.55333 9.6475 8.71 9.6025C8.86667 9.5575 9.005 9.48917 9.125 9.3975C9.245 9.30583 9.34083 9.18833 9.4125 9.045C9.48417 8.90167 9.52 8.73 9.52 8.53C9.52 8.32667 9.485 8.15583 9.415 8.0175C9.345 7.87917 9.25083 7.7675 9.1325 7.6825C9.01417 7.5975 8.87583 7.5375 8.7175 7.5025C8.55917 7.4675 8.39333 7.45 8.22 7.45ZM8.18001 8.99C8.35001 8.99 8.47584 8.95001 8.55751 8.87C8.63917 8.79 8.68001 8.67667 8.68001 8.53C8.68001 8.38334 8.63667 8.28001 8.55001 8.22001C8.46334 8.16 8.34001 8.13 8.18001 8.13H7.82001V8.99H8.18001ZM11.0678 9.9675C10.9645 9.99583 10.8545 10.01 10.7378 10.01H10.6878V8.14H10.7378C10.8545 8.14 10.9645 8.1525 11.0678 8.1775C11.1711 8.2025 11.2603 8.24833 11.3353 8.315C11.4103 8.38167 11.4695 8.475 11.5128 8.595C11.5561 8.715 11.5778 8.87 11.5778 9.06C11.5778 9.25 11.5561 9.40667 11.5128 9.53C11.4695 9.65333 11.4103 9.75 11.3353 9.82C11.2603 9.89 11.1711 9.93917 11.0678 9.9675Z"
  }))
});
export var ForbiddenIcon = makeIcon({
  displayName: 'ForbiddenIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M4.5 12.9c1 .7 2.2 1.1 3.5 1.1 3.3 0 6-2.7 6-6 0-1.3-.4-2.5-1.1-3.5l-8.4 8.4zm-1.4-1.4l8.4-8.4C10.5 2.4 9.3 2 8 2 4.7 2 2 4.7 2 8c0 1.3.4 2.5 1.1 3.5zM8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
  })
});
export var HeaderOneIcon = makeIcon({
  displayName: 'HeaderOneIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M6.667 13.333V2.667H0V.75C0 .336.336 0 .75 0h14.5c.414 0 .75.336.75.75v1.917H9.333v10.666h1.334c.736 0 1.333.597 1.333 1.334 0 .736-.597 1.333-1.333 1.333H5.333C4.597 16 4 15.403 4 14.667c0-.737.597-1.334 1.333-1.334h1.334z"
  }), React.createElement("rect", {
    x: "0",
    y: "0",
    width: "2.667",
    height: "5.333",
    rx: "1.333"
  }), React.createElement("rect", {
    x: "13.333",
    y: "0",
    width: "2.667",
    height: "5.333",
    rx: "1.333"
  }))
});
export var HeaderTwoIcon = makeIcon({
  displayName: 'HeaderTwoIcon',
  viewBox: 16,
  content: React.createElement("g", {
    transform: "translate(2 4)"
  }, React.createElement("path", {
    d: "M4.8 9.6V2.4H0V.75C0 .336.336 0 .75 0h10.5c.414 0 .75.336.75.75V2.4H7.2v7.2h1.2c.663 0 1.2.537 1.2 1.2 0 .663-.537 1.2-1.2 1.2H3.6c-.663 0-1.2-.537-1.2-1.2 0-.663.537-1.2 1.2-1.2h1.2z"
  }), React.createElement("rect", {
    x: "0",
    y: "0",
    width: "2.4",
    height: "4.8",
    rx: "1.2"
  }), React.createElement("rect", {
    x: "9.6",
    y: "0",
    width: "2.4",
    height: "4.8",
    rx: "1.2"
  }))
});
export var Heading1Icon = makeIcon({
  displayName: 'HeaderTwoIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M0 1a1 1 0 112 0v6h6V1a1 1 0 012 0v14a1 1 0 11-2 0V9H2v6a1 1 0 11-2 0V1zM14.42 9.52a.8.8 0 01.38.68v5a.8.8 0 01-1.6 0v-3.706l-.842.421a.8.8 0 11-.716-1.43l2-1a.8.8 0 01.779.034z"
  })
});
export var Heading2Icon = makeIcon({
  displayName: 'HeaderTwoIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M0 1a1 1 0 112 0v6h6V1a1 1 0 012 0v14a1 1 0 11-2 0V9H2v6a1 1 0 11-2 0V1zM13.857 10.997a.597.597 0 00-.851.324l-.052.145a.8.8 0 11-1.508-.532l.05-.145a2.197 2.197 0 113.784 2.108L14.07 14.4h1.13a.8.8 0 010 1.6h-2.8a.8.8 0 01-.623-1.302l2.257-2.804a.597.597 0 00-.177-.897z"
  })
});
export var Heading3Icon = makeIcon({
  displayName: 'HeaderTwoIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M0 1a1 1 0 112 0v6h6V1a1 1 0 012 0v14a1 1 0 11-2 0V9H2v6a1 1 0 11-2 0V1zM13.671 10.479a.604.604 0 00-.716.29l-.25.469a.8.8 0 01-1.41-.753l.249-.468c.5-.939 1.6-1.386 2.614-1.062 1.546.493 1.944 2.304 1.097 3.428.93 1.219.382 3.143-1.26 3.554a2.259 2.259 0 01-2.145-.594l-.416-.416a.8.8 0 111.132-1.132l.416.416a.659.659 0 10.83-1.013l-.256-.171a.8.8 0 01.129-1.401l.04-.018a.603.603 0 00-.054-1.13z"
  })
});
export var HighlightIcon = makeIcon({
  displayName: 'Highlight',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M0 15c0-.6.4-1 1-1h5c.6 0 1 .4 1 1s-.4 1-1 1H1c-.6 0-1-.4-1-1z",
    opacity: ".6"
  }), React.createElement("path", {
    d: "M5.84 9.162l3.4-8.4c.2-.6.9-.9 1.6-.7l4.3 1.4c.6.2 1 .9.8 1.5l-2.3 8.7-7.8-2.5zm2.7-1.3l3.7 1.2 1.6-6-3-1-2.3 5.8zM4.983 11.604a1 1 0 00.011.787l.406.909-.68 2.042a.5.5 0 00.474.658h5.281a.5.5 0 00.457-.297l.268-.603.95-.443a1 1 0 00.52-.571l.53-1.486-7.6-2.5-.617 1.504z"
  }))
});
export var ImageIcon = makeIcon({
  displayName: 'ImageIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M0 3a3 3 0 013-3h10a3 3 0 013 3v10a3 3 0 01-3 3H3a3 3 0 01-3-3V3zm3-1a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1V3a1 1 0 00-1-1H3zm8 1a2 2 0 110 4 2 2 0 010-4zM4.696 7.585L3.044 9.39v3.002a.5.5 0 00.5.5H12.5a.5.5 0 00.5-.5V9.39l-1.714-1.322a.78.78 0 00-1.006.046L8.9 9.39a.78.78 0 01-1.053.005l-2.051-1.86a.78.78 0 00-1.1.05z"
  })
});
export var InfoIcon = makeIcon({
  viewBox: 16,
  displayName: 'InfoIcon',
  content: React.createElement("g", null, React.createElement("path", {
    d: "M8,16c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S12.4,16,8,16z M8,14c3.3,0,6-2.7,6-6s-2.7-6-6-6 S2,4.7,2,8S4.7,14,8,14z M8,6.7c0.6,0,1,0.4,1,1v3.7c0,0.6-0.4,1-1,1s-1-0.4-1-1V7.7C7,7.1,7.4,6.7,8,6.7z M8,3.7c0.6,0,1,0.4,1,1 s-0.4,1-1,1s-1-0.4-1-1S7.4,3.7,8,3.7z"
  }))
});
export var ItalicIcon = makeIcon({
  displayName: 'ItalicIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M8.52 4.96c.935-.468 1.98.402 1.689 1.407l-2.026 6.996.286-.127a1 1 0 01.812 1.828l-1.857.825c-.932.415-1.924-.45-1.64-1.43L7.78 7.565a1 1 0 01-.852-1.81l1.591-.795z"
  }), React.createElement("circle", {
    cx: "9.5",
    cy: "1.5",
    r: "1.5"
  }))
});
export var LinkIcon = makeIcon({
  displayName: 'LinkIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M6.594 4.518a1 1 0 010-1.414l.973-.972a4.5 4.5 0 116.364 6.364l-.973.972a1 1 0 11-1.414-1.414l.973-.972A2.5 2.5 0 008.98 3.546l-.972.972a1 1 0 01-1.415 0zm-1.422 6.31a1 1 0 010-1.414l4.242-4.242a1 1 0 011.415 1.414l-4.243 4.242a1 1 0 01-1.414 0zm4.234 2.068a1 1 0 10-1.415-1.414l-.972.972a2.5 2.5 0 01-3.535-3.536l.972-.972a1 1 0 00-1.414-1.414l-.973.972a4.5 4.5 0 006.364 6.364l.973-.972z"
  })
});
export var MailIcon = makeIcon({
  displayName: 'MailIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M2 4v8h12V4H2zm0-2h12c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2H2c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2zm2.448 3.106c-.494-.247-1.095-.048-1.342.446-.247.494-.048 1.095.446 1.342l3.994 2c.284.142.618.14.9-.003l3.932-2c.492-.25.688-.85.438-1.34-.25-.493-.853-.69-1.345-.44L7.99 6.88 4.448 5.106z"
  })
});
export var MentionIcon = makeIcon({
  displayName: 'MentionIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M4.082 8.121c0 2.304 1.634 3.944 3.82 3.944 1.027 0 1.867-.425 2.42-1 .418.622 1.134 1 2.044 1 2.075 0 3.298-1.727 3.298-4.7 0-4.088-3.06-7.145-7.546-7.145C3.635.22.338 3.578.338 8.05c0 4.414 3.35 7.738 7.654 7.738 1.221 0 2.255-.206 3.106-.55.522-.213.873-.43 1.058-.588a.4.4 0 00.083-.514l-.54-.881a.4.4 0 00-.557-.128c-.788.507-1.836.764-3.15.764-3.288 0-5.612-2.445-5.612-5.86C2.38 4.657 4.765 2.1 8.1 2.1c3.386 0 5.558 2.132 5.558 5.285 0 1.889-.504 2.802-1.202 2.802-.504 0-.698-.252-.698-.914V5.288a1.003 1.003 0 00-1.88-.486c-.512-.37-1.199-.624-2.012-.624-2.15 0-3.784 1.657-3.784 3.943zm3.91 2.028c-1.063 0-1.814-.8-1.814-2.028 0-1.225.748-2.011 1.796-2.011 1.111 0 1.832.774 1.832 1.975 0 1.31-.743 2.064-1.814 2.064z"
  })
});
export var MoreIcon = makeIcon({
  displayName: 'MoreIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M8 4C9.10455 4 10 3.10457 10 2C10 0.895431 9.10455 0 8 0C6.89545 0 6 0.895431 6 2C6 3.10457 6.89545 4 8 4ZM8 10C9.10455 10 10 9.10457 10 8C10 6.89543 9.10455 6 8 6C6.89545 6 6 6.89543 6 8C6 9.10457 6.89545 10 8 10ZM10 14C10 15.1046 9.10455 16 8 16C6.89545 16 6 15.1046 6 14C6 12.8954 6.89545 12 8 12C9.10455 12 10 12.8954 10 14Z"
  }))
});
export var NarrowBlockIcon = makeIcon({
  displayName: 'NarrowBlockIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M2.963 10.121a1 1 0 1 0 1.414 1.415L7.14 8.773a.998.998 0 0 0 .294-1.127.996.996 0 0 0-.228-.353L4.377 4.464A1 1 0 0 0 2.963 5.88l1.125 1.125H1a1 1 0 0 0 0 2h3.08l-1.117 1.117zM16 7.996a1 1 0 0 0-1-1h-3.08l1.117-1.117a1 1 0 0 0-1.414-1.415L8.86 7.227a.998.998 0 0 0-.294 1.128.996.996 0 0 0 .228.352l2.829 2.829a1 1 0 0 0 1.414-1.415l-1.125-1.125H15a1 1 0 0 0 1-1z"
  })
});
export var NoteIcon = makeIcon({
  displayName: 'NoteIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M1 3a3 3 0 013-3h8a3 3 0 013 3v10a3 3 0 01-3 3H4a3 3 0 01-3-3V3zm3-1a1 1 0 00-1 1v10a1 1 0 001 1h8a1 1 0 001-1V3a1 1 0 00-1-1H4z"
  }), React.createElement("rect", {
    x: "5",
    y: "4",
    width: "6",
    height: "2",
    rx: "1"
  }), React.createElement("rect", {
    x: "5",
    y: "7",
    width: "4",
    height: "2",
    rx: "1"
  }))
});
export var NumberIcon = makeIcon({
  displayName: 'NumberIcon',
  viewBox: 16,
  content: React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1a1 1 0 0 0-2 0v3H1a1 1 0 1 0 0 2h3v4H1a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0v-3h4v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2h-3V6h3a1 1 0 1 0 0-2h-3V1a1 1 0 1 0-2 0v3H6V1zm4 9V6H6v4h4z",
    fill: "currentColor"
  })
});
export var OrderedListIcon = makeIcon({
  displayName: 'OrderedListIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M1.65 4.8h.706V1.24H2.28l-1.472.528v.574l.842-.262V4.8zM6 2a1 1 0 000 2h9a1 1 0 100-2H6zm0 5a1 1 0 000 2h9a1 1 0 100-2H6zm-1 6a1 1 0 011-1h9a1 1 0 110 2H6a1 1 0 01-1-1zM3.078 9.8H.642v-.483l1.15-1.226c.157-.173.274-.323.35-.452a.726.726 0 00.113-.366.543.543 0 00-.12-.372c-.079-.09-.193-.136-.34-.136a.466.466 0 00-.378.165.653.653 0 00-.138.433H.57c0-.216.052-.414.155-.593.103-.179.25-.32.438-.42.189-.103.403-.154.642-.154.366 0 .65.088.854.264.202.176.303.424.303.745 0 .176-.045.355-.136.537a2.984 2.984 0 01-.469.637l-.808.852h1.528V9.8zm-1.343 2.91H1.36v.552h.374c.39 0 .586.177.586.532a.46.46 0 01-.143.353.556.556 0 01-.394.133.553.553 0 01-.37-.127.409.409 0 01-.15-.327H.556c0 .307.113.555.338.742.226.187.516.28.87.28.38 0 .685-.094.915-.285a.936.936 0 00.346-.76.874.874 0 00-.148-.507.883.883 0 00-.448-.322.967.967 0 00.39-.315.748.748 0 00.15-.45c0-.315-.107-.563-.32-.743-.214-.18-.508-.27-.884-.27-.217 0-.415.042-.595.125a1 1 0 00-.42.345.868.868 0 00-.15.5h.706c0-.12.045-.216.136-.29a.521.521 0 01.34-.11c.15 0 .267.04.353.119.085.08.128.191.128.334a.492.492 0 01-.13.357c-.086.09-.218.134-.398.134z"
  })
});
export var PenIcon = makeIcon({
  displayName: 'PenIcon',
  viewBox: 18,
  content: React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.707.879a3 3 0 0 0-4.243 0l-8.899 8.9a2 2 0 0 0-.586 1.413v3.829a1 1 0 0 0 1 1h3.829a2 2 0 0 0 1.414-.586l8.9-8.9a3 3 0 0 0 0-4.242L14.706.879zM11.88 2.293a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1 0 1.414l-.686.687-2.829-2.829.687-.686zm-2.1 2.1l-6.8 6.8v2.828h2.829l6.799-6.8-2.829-2.828z"
  }))
});
export var PeopleIcon = makeIcon({
  displayName: 'PeopleIcon',
  viewBox: 16,
  content: React.createElement("g", {
    transform: "translate(1)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }, React.createElement("circle", {
    cx: "7",
    cy: "4",
    r: "3"
  }), React.createElement("path", {
    d: "M3.5 10C2.12 10 1 11.12 1 12.5v.5c0 1.105.895 2 2 2h8c1.105 0 2-.895 2-2v-.5c0-1.38-1.12-2.5-2.5-2.5h-7z"
  }))
});
export var PlusIcon = makeIcon({
  displayName: 'PlusIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M9 7V1c0-.552-.448-1-1-1S7 .448 7 1v6H1c-.552 0-1 .448-1 1s.448 1 1 1h6v6c0 .552.448 1 1 1s1-.448 1-1V9h6c.552 0 1-.448 1-1s-.448-1-1-1H9z"
  })
});
export var QuoteIcon = makeIcon({
  displayName: 'QuoteIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M6.421 2.786a1 1 0 01-.762 1.19C3.799 4.386 2 6.288 2 8.557A3.222 3.222 0 114.333 14l-.014-.001c-1.505-.005-2.62-.805-3.32-1.867C.313 11.095 0 9.784 0 8.556c0-3.288 2.533-5.941 5.23-6.533a1 1 0 011.191.763zm8.4 0a1 1 0 01-.762 1.19c-1.86.409-3.659 2.311-3.659 4.58A3.222 3.222 0 1112.733 14l-.014-.001c-1.505-.005-2.62-.805-3.32-1.867-.685-1.038-.999-2.35-.999-3.577 0-3.288 2.533-5.941 5.23-6.533a1 1 0 011.191.763z"
  })
});
export var RecentIcon = makeIcon({
  displayName: 'RecentIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M8 14c3.314 0 6-2.686 6-6s-2.686-6-6-6-6 2.686-6 6 2.686 6 6 6zm0 2c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z"
  }), React.createElement("path", {
    d: "M9 8V5c0-.552-.448-1-1-1s-1 .448-1 1v4c0 .276.112.526.293.707.18.18.43.293.707.293h3c.552 0 1-.448 1-1s-.448-1-1-1H9z"
  }))
});
export var SearchIcon = makeIcon({
  displayName: 'SearchIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M11.213 12.93c-.466-.454-.467-1.2-.01-1.655l-.04.038c.46-.46 1.216-.46 1.677-.01l2.798 2.724c.466.454.466 1.2.01 1.654l.04-.034c-.46.46-1.216.46-1.678.01l-2.797-2.723zM6 12c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6zm0-2c2.21 0 4-1.79 4-4S8.21 2 6 2 2 3.79 2 6s1.79 4 4 4z"
  })
});
export var SeparatorIcon = makeIcon({
  displayName: 'SeparatorIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M0 8a1 1 0 011-1h14a1 1 0 110 2H1a1 1 0 01-1-1z"
  })
});
export var SpinnerIcon = makeIcon({
  displayName: 'Spinner',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M8,16c-4.4,0-8-3.6-8-8s3.6-8,8-8c2,0,4,0.8,5.5,2.2c0.4,0.4,0.4,1,0,1.4s-1,0.4-1.4,0 C11,2.6,9.5,2,8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6c0-0.6,0.4-1,1-1s1,0.4,1,1C16,12.4,12.4,16,8,16z"
  }))
});
export var StrikethroughIcon = makeIcon({
  displayName: 'StrikethroughIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M12.8 2.4a1 1 0 11-1.6 1.2C10.4 2.533 9.2 2 7.5 2 5.302 2 4 3.302 4 5c0 1.22 1.364 1.999 3.986 2H15a1 1 0 110 2H1a1 1 0 010-2h1.601C2.211 6.445 2 5.777 2 5c0-2.802 2.198-5 5.5-5 2.3 0 4.1.8 5.3 2.4zm-.82 8.35h2.013c.005.082.007.166.007.25-.002 2.741-2.642 5-6 5-2.354 0-4.322-1.18-5.832-3.445a1 1 0 011.664-1.11C4.989 13.181 6.354 14 8 14c2.317 0 3.999-1.439 4-3 0-.086-.006-.17-.02-.25z"
  })
});
export var SubscriptIcon = makeIcon({
  displayName: 'SubscriptIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M13.857 10.997a.597.597 0 00-.851.324l-.052.145a.8.8 0 11-1.508-.532l.05-.145a2.197 2.197 0 113.784 2.108L14.07 14.4h1.13a.8.8 0 010 1.6h-2.8a.8.8 0 01-.623-1.302l2.257-2.804a.597.597 0 00-.177-.897zM0 2.75A.75.75 0 01.75 2h8.5a.75.75 0 01.75.75V5a1 1 0 11-2 0V4H6v8h1a1 1 0 110 2H3a1 1 0 110-2h1V4H2v1a1 1 0 01-2 0V2.75z"
  })
});
export var SuperscriptIcon = makeIcon({
  displayName: 'SuperscriptIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M13.857 1.675a.597.597 0 00-.851.324l-.052.145a.8.8 0 01-1.508-.532l.05-.145a2.197 2.197 0 113.784 2.109l-1.21 1.502h1.13a.8.8 0 010 1.6h-2.8a.8.8 0 01-.623-1.301l2.257-2.805a.597.597 0 00-.177-.897zM0 2.75A.75.75 0 01.75 2h8.5a.75.75 0 01.75.75V5a1 1 0 11-2 0V4H6v8h1a1 1 0 110 2H3a1 1 0 110-2h1V4H2v1a1 1 0 01-2 0V2.75z"
  })
});
export var TagIcon = makeIcon({
  displayName: 'TagIcon',
  content: React.createElement("path", {
    d: "M13.1548 0.380662C12.9673 0.193125 12.713 0.0877686 12.4477 0.0877686H8.91221C8.64699 0.0877686 8.39264 0.193125 8.2051 0.380662L0.426927 8.15884C0.0364019 8.54936 0.0364022 9.18253 0.426927 9.57305L6.43733 15.5835C6.82786 15.974 7.46102 15.974 7.85155 15.5835L15.6297 7.80528C15.8173 7.61775 15.9226 7.36339 15.9226 7.09818V3.56264C15.9226 3.29743 15.8173 3.04307 15.6297 2.85554L13.1548 0.380662ZM9.32642 2.08777H12.0335L13.9226 3.97686V6.68396L7.14444 13.4621L2.54825 8.86594L9.32642 2.08777ZM10.1496 5.86074C10.5401 6.25127 11.1733 6.25127 11.5638 5.86074C11.9544 5.47022 11.9544 4.83705 11.5638 4.44653C11.1733 4.056 10.5401 4.056 10.1496 4.44653C9.7591 4.83705 9.7591 5.47022 10.1496 5.86074Z",
    fill: "currentColor"
  })
});
export var TagsIcon = makeIcon({
  displayName: 'TagsIcon',
  content: React.createElement("path", {
    d: "M10.0538 0.0203289C10.3557 -0.0132185 10.6565 0.0922982 10.8713 0.307106L12.9927 2.42843C13.2075 2.64323 13.313 2.94404 13.2794 3.24596L12.9259 6.42795C12.9008 6.65363 12.7997 6.86406 12.6391 7.02462L6.67645 12.9873C6.28592 13.3778 5.65276 13.3778 5.26223 12.9873L0.312486 8.03754C0.124949 7.85 0.0195923 7.59565 0.0195923 7.33043C0.0195923 7.06521 0.124949 6.81086 0.312486 6.62332L6.27515 0.660659C6.43571 0.500095 6.64614 0.398958 6.87182 0.373882L10.0538 0.0203289ZM9.79698 2.06117L7.44132 2.32291L2.43381 7.33043L5.96934 10.866L10.9769 5.85845L11.2386 3.50279L9.79698 2.06117ZM15.1877 4.14719C15.7336 4.23125 16.108 4.74189 16.0239 5.28774L15.509 8.63102C15.4767 8.84118 15.3782 9.03556 15.2278 9.18592L8.72108 15.6926C8.33838 16.0753 7.72066 16.0841 7.32724 15.7124L6.81329 15.2269C6.41183 14.8476 6.39384 14.2147 6.77311 13.8133C7.08914 13.4787 7.58127 13.4105 7.96887 13.6164L13.5822 8.00314L14.0472 4.98334C14.1313 4.43748 14.6419 4.06313 15.1877 4.14719ZM8.44424 4.85556C8.73713 5.14845 9.21201 5.14845 9.5049 4.85556C9.79779 4.56266 9.79779 4.08779 9.5049 3.7949C9.21201 3.502 8.73713 3.502 8.44424 3.7949C8.15135 4.08779 8.15135 4.56266 8.44424 4.85556Z",
    fill: "currentColor"
  })
});
export var TableAddIcon = makeIcon({
  displayName: 'TableAdd',
  content: React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, React.createElement("path", {
    d: "M8,14 C11.31365,14 14,11.31365 14,8 C14,4.68629 11.31365,2 8,2 C4.68629,2 2,4.68629 2,8 C2,11.31365 4.68629,14 8,14 Z M8,16 C12.4182667,16 16,12.4182667 16,8 C16,3.58172 12.4182667,0 8,0 C3.58172,0 0,3.58172 0,8 C0,12.4182667 3.58172,16 8,16 Z"
  }), React.createElement("path", {
    d: "M7.25,5.75 C7.25,5.33579 7.5857675,5 8,5 C8.4142325,5 8.75,5.33579 8.75,5.75 L8.75,7.25 L10.25,7.25 C10.664225,7.25 11,7.5857825 11,8 C11,8.4142175 10.664225,8.75 10.25,8.75 L8.75,8.75 L8.75,10.25 C8.75,10.664225 8.4142325,11 8,11 C7.5857675,11 7.25,10.664225 7.25,10.25 L7.25,8.75 L5.75,8.75 C5.3357675,8.75 5,8.4142175 5,8 C5,7.5857825 5.3357675,7.25 5.75,7.25 L7.25,7.25 L7.25,5.75 Z"
  }))
});
export var TableIcon = makeIcon({
  displayName: 'TableIcon',
  viewBox: 16,
  content: React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.499 0H13.5A2.499 2.499 0 0116 2.499V13.5A2.499 2.499 0 0113.501 16H2.5A2.499 2.499 0 010 13.501V2.5A2.499 2.499 0 012.499 0zm6.375 4.7H14V2.612A.612.612 0 0013.388 2H8.874v2.7zM7 4.7V2H2.612A.612.612 0 002 2.612V4.7h5zm0 2v2.6H2V6.7h5zm1.874 2.6V6.7H14v2.6H8.874zM7 11.3H2v2.088c0 .338.274.612.612.612H7v-2.7zM8.874 14v-2.7H14v2.088a.612.612 0 01-.612.612H8.874z"
  })
});
export var TextWrap = makeIcon({
  displayName: 'TextWrap',
  viewBox: 16,
  content: React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 1a1 1 0 011-1h14a1 1 0 110 2H1a1 1 0 01-1-1zm0 5.7a1 1 0 011-1h11.125a3.875 3.875 0 110 7.75H10a1 1 0 110-2h2.125a1.875 1.875 0 000-3.75H1a1 1 0 01-1-1zm0 5.75c0-.552.42-1 .938-1h3.125c.517 0 .937.448.937 1s-.42 1-.938 1H.938c-.517 0-.937-.448-.937-1z"
  }), React.createElement("path", {
    d: "M11.142 9.242a.908.908 0 010 1.284l-1.926 1.927 1.926 1.926a.908.908 0 01-1.284 1.284l-2.569-2.568a.908.908 0 010-1.285l2.569-2.568a.908.908 0 011.284 0z"
  }))
});
export var ThinChevronIcon = makeIcon({
  displayName: 'ThinChevronIcon',
  content: React.createElement("path", {
    d: "M10.5858 8L4.29289 1.70711C3.90237 1.31658 3.90237 0.683418 4.29289 0.292893C4.68342 -0.0976311 5.31658 -0.0976311 5.70711 0.292893L12.7071 7.29289C13.0976 7.68342 13.0976 8.31658 12.7071 8.70711L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L10.5858 8Z"
  })
});
export var UnderlineIcon = makeIcon({
  displayName: 'UnderlineIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M3.5 0a1 1 0 00-1 1v5.5a5.5 5.5 0 1011 0V1a1 1 0 10-2 0v5.5a3.5 3.5 0 11-7 0V1a1 1 0 00-1-1zM2 14a1 1 0 100 2h12a1 1 0 100-2H2z"
  })
});
export var ExpandBlockIcon = makeIcon({
  displayName: 'ExpandBlockIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M4.537 4.464a1 1 0 0 1 0 1.415L3.42 6.996h9.16l-1.117-1.117a1 1 0 0 1 1.414-1.415l2.763 2.763a.998.998 0 0 1 .294 1.128.996.996 0 0 1-.228.352l-2.829 2.829a1 1 0 0 1-1.414-1.415l1.125-1.125H3.412l1.125 1.125a1 1 0 1 1-1.414 1.415L.47 8.882C.19 8.715 0 8.381 0 7.996c0-.394.2-.735.49-.898l2.633-2.634a1 1 0 0 1 1.414 0z"
  })
});
export var PlaceholderIcon = makeIcon({
  displayName: 'PlaceholderIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M0 3c0 .6.4 1 1 1s1-.4 1-1 .4-1 1-1 1-.4 1-1-.4-1-1-1C1.3 0 0 1.3 0 3zm6-1h4c.6 0 1-.4 1-1s-.4-1-1-1H6c-.6 0-1 .4-1 1s.4 1 1 1zm-5 9c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1s1 .4 1 1v4c0 .6-.4 1-1 1zm-1 2c0 1.7 1.3 3 3 3 .6 0 1-.4 1-1s-.4-1-1-1-1-.4-1-1-.4-1-1-1-1 .4-1 1zm10 3H6c-.6 0-1-.4-1-1s.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1zm2-1c0 .6.4 1 1 1 1.7 0 3-1.3 3-3 0-.6-.4-1-1-1s-1 .4-1 1-.4 1-1 1-1 .4-1 1zm3-4c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1s1 .4 1 1v4c0 .6-.4 1-1 1zm-1-8c0 .6.4 1 1 1s1-.4 1-1c0-1.7-1.3-3-3-3-.6 0-1 .4-1 1s.4 1 1 1 1 .4 1 1z"
  })
});
export var WindowsIcon = makeIcon({
  displayName: 'WindowIcon',
  viewBox: 9,
  content: React.createElement("path", {
    d: "M0 1.3L3.7.8v3.5H0v-3zm3.7 3.4v3.5L0 7.7v-3h3.7zm.4-4L8.9 0v4.2H4.1V.7zm4.8 4V9l-4.8-.7V4.8l4.8-.1z"
  })
});
export var GripIcon = makeIcon({
  displayName: 'GripIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8C3 7.44772 3.44772 7 4 7H12C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9H4C3.44772 9 3 8.55228 3 8Z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4C3 3.44772 3.44772 3 4 3H12C12.5523 3 13 3.44772 13 4C13 4.55228 12.5523 5 12 5H4C3.44772 5 3 4.55228 3 4Z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12C3 11.4477 3.44772 11 4 11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H4C3.44772 13 3 12.5523 3 12Z"
  }))
});
export var SwitchIcon = makeIcon({
  displayName: 'Switch',
  viewBox: 16,
  content: React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29289 11.4629C1.68342 11.0724 2.31658 11.0724 2.70711 11.4629L3.82421 12.58L3.82421 5C3.82421 4.44772 4.27193 4 4.82421 4C5.37649 4 5.82421 4.44771 5.82421 5L5.82421 12.5884L6.94975 11.4629C7.34027 11.0724 7.97344 11.0724 8.36396 11.4629C8.75448 11.8534 8.75448 12.4866 8.36396 12.8771L5.53553 15.7055C5.43228 15.8088 5.31206 15.8847 5.18385 15.9334C5.07225 15.9764 4.95098 16 4.82421 16C4.51537 16 4.23924 15.86 4.0558 15.64L1.29289 12.8771C0.902369 12.4866 0.902369 11.8534 1.29289 11.4629ZM14.7071 4.53712C14.3166 4.92765 13.6834 4.92765 13.2929 4.53712L12.1758 3.42002L12.1758 11C12.1758 11.5523 11.7281 12 11.1758 12C10.6235 12 10.1758 11.5523 10.1758 11L10.1758 3.41159L9.05025 4.53712C8.65973 4.92765 8.02656 4.92765 7.63604 4.53712C7.24551 4.1466 7.24551 3.51343 7.63604 3.12291L10.4645 0.294483C10.5677 0.191227 10.6879 0.115273 10.8161 0.0666194C10.9278 0.0235897 11.049 -4.39256e-07 11.1758 -4.44798e-07C11.4846 -4.58298e-07 11.7608 0.140001 11.9442 0.360002L14.7071 3.12291C15.0976 3.51343 15.0976 4.1466 14.7071 4.53712Z"
  })
});
export var RecycleIcon = makeIcon({
  displayName: 'Recycle',
  content: React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6024 2.25C7.8548 2.25 7.14444 2.3986 6.49734 2.66694C5.82374 2.94627 5.21676 3.3562 4.70842 3.8658C4.43705 4.13785 4.19415 4.43796 3.98441 4.76124C3.68382 5.22456 3.10577 5.47346 2.59561 5.26191C2.08545 5.05035 1.83783 4.46087 2.11553 3.98348C2.4416 3.42297 2.838 2.90894 3.29245 2.45336C3.98386 1.76021 4.81086 1.20115 5.73124 0.81949C6.61693 0.452212 7.58731 0.25 8.6024 0.25C9.61749 0.25 10.5879 0.452212 11.4736 0.819492C12.391 1.19993 13.2156 1.75663 13.9057 2.44669C14.3691 2.91005 14.7723 3.43409 15.1024 4.00616V1.75C15.1024 1.19772 15.5501 0.75 16.1024 0.75C16.6547 0.75 17.1024 1.19772 17.1024 1.75V6.75C17.1024 7.30228 16.6547 7.75 16.1024 7.75H11.1024C10.5501 7.75 10.1024 7.30228 10.1024 6.75C10.1024 6.19771 10.5501 5.75 11.1024 5.75H13.7363C13.7175 5.71639 13.7006 5.68136 13.6855 5.64496C13.407 4.97351 12.9988 4.36825 12.4915 3.86091C11.9841 3.35358 11.3789 2.94538 10.7075 2.66694C10.0603 2.3986 9.34999 2.25 8.6024 2.25ZM9.39765 13.75C10.1452 13.75 10.8556 13.6014 11.5027 13.3331C12.1763 13.0537 12.7833 12.6438 13.2916 12.1342C13.563 11.8621 13.8059 11.562 14.0156 11.2388C14.3162 10.7754 14.8943 10.5265 15.4044 10.7381C15.9146 10.9496 16.1622 11.5391 15.8845 12.0165C15.5584 12.577 15.162 13.0911 14.7076 13.5466C14.0162 14.2398 13.1892 14.7988 12.2688 15.1805C11.3831 15.5478 10.4127 15.75 9.39765 15.75C8.38256 15.75 7.41217 15.5478 6.52648 15.1805C5.60905 14.8001 4.78441 14.2434 4.09435 13.5533C3.63099 13.0899 3.22776 12.5659 2.89764 11.9938V14.25C2.89764 14.8023 2.44993 15.25 1.89764 15.25C1.34536 15.25 0.897644 14.8023 0.897644 14.25V9.25C0.897644 8.69771 1.34536 8.25 1.89764 8.25L6.89764 8.25C7.44993 8.25 7.89764 8.69771 7.89764 9.25C7.89764 9.80228 7.44993 10.25 6.89764 10.25H4.26376C4.28249 10.2836 4.29949 10.3186 4.31458 10.355C4.59302 11.0265 5.00122 11.6317 5.50856 12.1391C6.0159 12.6464 6.62115 13.0546 7.29259 13.3331C7.93969 13.6014 8.65005 13.75 9.39765 13.75Z"
  })
});
export var WarningIcon = makeIcon({
  displayName: 'WarningIcon',
  viewBox: 16,
  content: React.createElement("path", {
    d: "M8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm0 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 7.3c-.6 0-1-.4-1-1V4.6c0-.6.4-1 1-1s1 .4 1 1v3.7c0 .6-.4 1-1 1zm0 3c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
  })
});
export var InsertRightIcon = makeIcon({
  displayName: 'InsertRight',
  viewBox: 16,
  content: React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M16 13a3 3 0 01-3 3H7V0h6a3 3 0 013 3v10zm-3 1a1 1 0 001-1V3a1 1 0 00-1-1H9v12h4z"
  }), React.createElement("circle", {
    cx: "4.5",
    cy: "1",
    r: "1",
    transform: "rotate(-180 4.5 1)"
  }), React.createElement("circle", {
    cx: "4.5",
    cy: "15",
    r: "1",
    transform: "rotate(-180 4.5 15)"
  }), React.createElement("circle", {
    cx: "1.5",
    cy: "14.5",
    r: "1",
    transform: "rotate(-180 1.5 14.5)"
  }), React.createElement("circle", {
    cx: "1",
    cy: "11.5",
    r: "1",
    transform: "rotate(-180 1 11.5)"
  }), React.createElement("circle", {
    cx: "1",
    cy: "8",
    r: "1",
    transform: "rotate(-180 1 8)"
  }), React.createElement("circle", {
    cx: "1.5",
    cy: "1.5",
    r: "1",
    transform: "rotate(-180 1.5 1.5)"
  }), React.createElement("circle", {
    cx: "1",
    cy: "4.5",
    r: "1",
    transform: "rotate(-180 1 4.5)"
  }))
});
export var InsertLeftIcon = makeIcon({
  displayName: 'InsertLeft',
  viewBox: 16,
  content: React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M0 3a3 3 0 013-3h6v16H3a3 3 0 01-3-3V3zm3-1a1 1 0 00-1 1v10a1 1 0 001 1h4V2H3z"
  }), React.createElement("circle", {
    cx: "11.5",
    cy: "15",
    r: "1"
  }), React.createElement("circle", {
    cx: "11.5",
    cy: "1",
    r: "1"
  }), React.createElement("circle", {
    cx: "14.5",
    cy: "1.5",
    r: "1"
  }), React.createElement("circle", {
    cx: "15",
    cy: "4.5",
    r: "1"
  }), React.createElement("circle", {
    cx: "15",
    cy: "8",
    r: "1"
  }), React.createElement("circle", {
    cx: "14.5",
    cy: "14.5",
    r: "1"
  }), React.createElement("circle", {
    cx: "15",
    cy: "11.5",
    r: "1"
  }))
});
export var InsertTopIcon = makeIcon({
  displayName: 'InsertTop',
  viewBox: 16,
  content: React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M13 0a3 3 0 013 3v6H0V3a3 3 0 013-3h10zm1 3a1 1 0 00-1-1H3a1 1 0 00-1 1v4h12V3z"
  }), React.createElement("circle", {
    cx: "1",
    cy: "11.5",
    r: "1",
    transform: "rotate(90 1 11.5)"
  }), React.createElement("circle", {
    cx: "15",
    cy: "11.5",
    r: "1",
    transform: "rotate(90 15 11.5)"
  }), React.createElement("circle", {
    cx: "14.5",
    cy: "14.5",
    r: "1",
    transform: "rotate(90 14.5 14.5)"
  }), React.createElement("circle", {
    cx: "11.5",
    cy: "15",
    r: "1",
    transform: "rotate(90 11.5 15)"
  }), React.createElement("circle", {
    cx: "8",
    cy: "15",
    r: "1",
    transform: "rotate(90 8 15)"
  }), React.createElement("circle", {
    cx: "1.5",
    cy: "14.5",
    r: "1",
    transform: "rotate(90 1.5 14.5)"
  }), React.createElement("circle", {
    cx: "4.5",
    cy: "15",
    r: "1",
    transform: "rotate(90 4.5 15)"
  }))
});
export var InsertBottomIcon = makeIcon({
  displayName: 'InsertBottom',
  viewBox: 16,
  content: React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M3 16a3 3 0 01-3-3V7h16v6a3 3 0 01-3 3H3zm-1-3a1 1 0 001 1h10a1 1 0 001-1V9H2v4z"
  }), React.createElement("circle", {
    cx: "15",
    cy: "4.5",
    r: "1",
    transform: "rotate(-90 15 4.5)"
  }), React.createElement("circle", {
    cx: "1",
    cy: "4.5",
    r: "1",
    transform: "rotate(-90 1 4.5)"
  }), React.createElement("circle", {
    cx: "1.5",
    cy: "1.5",
    r: "1",
    transform: "rotate(-90 1.5 1.5)"
  }), React.createElement("circle", {
    cx: "4.5",
    cy: "1",
    r: "1",
    transform: "rotate(-90 4.5 1)"
  }), React.createElement("circle", {
    cx: "8",
    cy: "1",
    r: "1",
    transform: "rotate(-90 8 1)"
  }), React.createElement("circle", {
    cx: "14.5",
    cy: "1.5",
    r: "1",
    transform: "rotate(-90 14.5 1.5)"
  }), React.createElement("circle", {
    cx: "11.5",
    cy: "1",
    r: "1",
    transform: "rotate(-90 11.5 1)"
  }))
});